import { Injectable } from '@angular/core';
import { ServiceBase } from './service-base';
import { UploadFileInformation } from '../../shared/data-objects/upload-file-information';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApplicationBase } from '../data-objects/application-base';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FileUploadService extends ServiceBase {
  fileList: FileList[];
  fileListSecondInstance: FileList[];

  private static get fileUploadUrl(): string {
    return ServiceBase.baseHref + '/api/fileupload/upload';
  }

  private static get updateFileInformationUrl(): string {
    return ServiceBase.baseHref + '/api/updatefileupload';
  }

  private static getCookie(name: string): string {
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i: any = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  constructor(private http: HttpClient) {
    super();

  }

  clearFiles() {
    this.fileList = null;
    this.fileListSecondInstance = null;
  }

  addFile(fileList: FileList[], isSecondInstance: boolean = false) {

    // this.fileList = fileList;

    if (!isSecondInstance) {
      this.fileList = fileList;
    } else {
      this.fileListSecondInstance = fileList;
    }

    // if (!this.fileList || (this.fileList && this.fileList.length === 0)) {
    //   this.fileList = fileList;
    // } else {
    //   // this.fileList = [...this.fileList, ...fileList];
    //   (this.fileList || []).push(...fileList);
    // }
  }


  uploadFile(token: string, isSecondInstance: boolean = false): Observable<string[]> {

    const allObservables: Observable<string>[] = [];

    const fileList = (!isSecondInstance) ? this.fileList : this.fileListSecondInstance;

    for (let i = 0; i < fileList.length; i++) {
      const file: any = fileList[i];
      allObservables.push(Observable.create((subscriber) => {
        const uploadError = (e): void => {
          subscriber.next(null);
          subscriber.complete();
        };
        const uploadComplete = (e): void => {
          if (e.target.status !== 200) {
            uploadError(e);
            return;
          }
          const locations = JSON.parse(e.target.responseText);
          subscriber.next(locations.err_desc);
          subscriber.complete();
        };

        const formData: FormData = new FormData();
        formData.append('file', file, ServiceBase.sanitizeString(file.name));

        const xhr: XMLHttpRequest = new XMLHttpRequest();
        xhr.open('POST', FileUploadService.fileUploadUrl, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', FileUploadService.getCookie('XSRF-TOKEN'));
        xhr.addEventListener('load', uploadComplete, false);
        xhr.addEventListener('error', uploadError, false);
        // xhr.addEventListener('abort', uploadAbort, false);
        xhr.send(formData);
      }
      ));
    }

    return Observable.forkJoin(allObservables);
  }

  // async uploadFile(token: string): Promise<any> {
  //   const promises = [];
  //   for (let i = 0; i < this.fileList.length; i++) {
  //     const file: File = this.fileList[i];
  //     const promise = await new Promise((resolve: any, reject: any) => {
  //       const formData: FormData = new FormData();
  //       const uploadError = (e: any): void => {
  //         console.log('uploadError', e);
  //         resolve(null);
  //       };
  //       const uploadComplete = (e: any): void => {
  //         console.log('uploadComplete', e);
  //         if (e.target.status !== 200) {
  //           uploadError(e);
  //           return;
  //         }
  //         const locations = JSON.parse(e.target.responseText);
  //         if (locations.hasOwnProperty('err_desc')) {
  //           resolve(locations.err_desc);
  //         } else if (locations.contains('Error')) {
  //           uploadError(e);
  //           return;
  //         };
  //       };

  //       formData.append('file', file, ServiceBase.sanitizeString(file.name));

  //       const xhr: XMLHttpRequest = new XMLHttpRequest();
  //       xhr.open('POST', FileUploadService.fileUploadUrl, true);
  //       xhr.setRequestHeader('Authorization', 'Bearer ' + token);
  //       xhr.setRequestHeader('Accept', 'application/json');
  //       xhr.setRequestHeader('X-XSRF-TOKEN', FileUploadService.getCookie('XSRF-TOKEN'));
  //       xhr.addEventListener('load', uploadComplete, false);
  //       xhr.addEventListener('error', uploadError, false);
  //       // xhr.addEventListener('abort', uploadAbort, false);
  //       xhr.send(formData);
  //     });

  //     promises.push(promise);
  //   }

  //   return await Promise.all(promises);
  // }

  updateFileInformation(uploadFileInfo: UploadFileInformation, token: string): Observable<boolean> {
    const cleanuploadFileInfo: ApplicationBase = ServiceBase.sanitize(uploadFileInfo);
    const header: HttpHeaders = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer ' + token);

    return this.http.post<boolean>(FileUploadService.updateFileInformationUrl, JSON.stringify(cleanuploadFileInfo), { headers: header });
  }

  isValid(isSecondInstance: boolean = false): boolean {
    if (!isSecondInstance) {
      if (!this.fileList) {
        return false;
      }

      return this.fileList.length > 0;
    } else {
      if (!this.fileListSecondInstance) {
        return false;
      }

      return this.fileListSecondInstance.length > 0;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/file-upload.service.ts